import { render, staticRenderFns } from "./ProductEditYoutube.vue?vue&type=template&id=7fa48992&scoped=true&"
import script from "./ProductEditYoutube.vue?vue&type=script&lang=js&"
export * from "./ProductEditYoutube.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditYoutube.vue?vue&type=style&index=0&id=7fa48992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa48992",
  null
  
)

export default component.exports